import { Provider } from "@angular/core";
import type { WkDataTableRowRegistration } from "@components/data-table/data-table.types";
import { getWkDataTableRowRegistry } from "@components/data-table/data-table.tokens";

export function provideWkDataTableRow<T extends WkDataTableRowRegistration = WkDataTableRowRegistration>(registration: T): Provider[] {
    return [
        registration.service,
        {
            provide: getWkDataTableRowRegistry<T>(),
            multi: true,
            useValue: registration,
        },
    ];
}
